/**
 * Storage wrapper service
 * Provides singleton interfaces for localStorage and sessionStorage access
 */

const makeStorage = (storage: Storage) => ({
  get(key: string): string | null {
    return storage.getItem(key)
  },

  set(key: string, value: string): void {
    storage.setItem(key, value)
  },

  remove(key: string): void {
    storage.removeItem(key)
  },

  getJSON<T = unknown>(key: string): T | null {
    const value = storage.getItem(key)
    if (!value) return null

    try {
      return JSON.parse(value) as T
    } catch {
      return null
    }
  },

  setJSON(key: string, value: unknown): void {
    storage.setItem(key, JSON.stringify(value))
  }
})

const local = makeStorage(localStorage)
const session = makeStorage(sessionStorage)

export const storageService = {
  ...local,
  session
}
